import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/**
 * Mutation types
*/
export const AUTH_STATE_NOAUTH = 'AUTH_STATE_NOAUTH'
export const AUTH_STATE_AUTHING = 'AUTH_STATE_AUTHING'
export const AUTH_STATE_AUTHED = 'AUTH_STATE_AUTHED'
export const LOADING_STATE_CHANGED = 'LOADING_STATE_CHANGED'
export const ADD_GLOBAL_MESSAGE = 'ADD_GLOBAL_MESSAGE'
export const REMOVE_GLOBAL_MESSAGE = 'REMOVE_GLOBAL_MESSAGE'

export default new Vuex.Store({
  state: {
    authState: null,
    user: {},
    pageLoading: false,
    globalMessages: [
      /**
       * {
       *  type: bootstrap color
       *  content: message content
       *  isProgressBar: show progress bar or not
       * }
      */
    ]
  },
  mutations: {
    [AUTH_STATE_NOAUTH] (state) {
      state.authState = AUTH_STATE_NOAUTH
    },
    [AUTH_STATE_AUTHING] (state) {
      state.authState = AUTH_STATE_AUTHING
    },
    [AUTH_STATE_AUTHED] (state, { email, emailVerified, uid, role }) {
      state.authState = AUTH_STATE_AUTHED
      state.user = {
        ...state.user,
        email,
        emailVerified,
        uid,
        role
      }
    },
    [LOADING_STATE_CHANGED] (state, nextStatus) {
      state.pageLoading = nextStatus
    },
    [ADD_GLOBAL_MESSAGE] (state, newMsg) {
      state.globalMessages.push(newMsg)
    },
    [REMOVE_GLOBAL_MESSAGE] (state, msgIndex) {
      const temp = state.globalMessages
      temp.splice(msgIndex, 1)
      console.log(temp)
      state.globalMessages = temp
    }
  },
  actions: {

  }
})



// WEBPACK FOOTER //
// ./src/store.js